import { useOnboardingStoreV2 } from '@forwardflow/store/onboardingStoreV2'
import { CampaignFilter, ICampaignFilterConfig } from '@forwardflow/features'

export const CampaignConfiguration = () => {
   const { getNextStep, setCampaignConfiguration, onboardingData } =
      useOnboardingStoreV2()

   const existingConfig = onboardingData?.campaignConfiguration

   // Normalize campaign_type: old onboarding states stored "both" as a string
   // which gets spread into ["b","o","t","h"] when treated as an array
   const normalizeCampaignType = (type: any): string[] | undefined => {
      if (!type) return undefined
      if (Array.isArray(type)) {
         return type.filter((t: string) => ['new-lead', 'revive', 'activity'].includes(t))
      }
      if (type === 'both') return ['new-lead', 'revive']
      return [type]
   }

   return (
      <CampaignFilter
         initialConfiguration={
            existingConfig
               ? {
                    campaign_type: normalizeCampaignType(existingConfig.campaign_type),
                    campaign_filters: existingConfig.campaign_filters || {
                       eligible_criteria: [],
                    },
                    first_to_contact: existingConfig.first_to_contact || {
                       buffer_time: 0,
                    },
                 }
               : undefined
         }
         onSave={(config: ICampaignFilterConfig) => {
            setCampaignConfiguration({
               ...onboardingData?.campaignConfiguration,
               ...config,
            })
         }}
         onNextStep={() => {
            getNextStep()
         }}
      />
   )
}
